import { darken } from 'polished';
import styled from 'styled-components';

export const Main = styled.a`
  width: 100%;
  max-width: 980px;
  text-decoration: none;
  border-radius: 6px;

  svg {
    width: 18px;
  }
  @media only screen and (max-width: 950px) {
    width: 100%;
    margin: 0px 18px 0px 0px;
  }

  border-left: 6px solid ${props => props.primaryColor};
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  :hover {
    background: ${darken(0.06, '#FFF')};
  }
  background: #ffffff;
  padding: 26px 24px;

  span.inclusive {
    margin: 0 10px;
    min-width: 95px;
    height: 20px;
    display: flex;
    align-items: baseline;
    justify-content: center;
    border-radius: 4px;
    color: #F4F5F7;
    background-color: #5243AA;
    font-family: Roboto;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
  }

  @media only screen and (max-width: 950px) {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 20px 18px 30px;
    width: 100%;
    background: #ffffff;
    border-radius: 4px 4px 0 0;
  }
`;

export const Title = styled.h3`
  color: #475467;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 23px;
  display: flex;
  align-items: felx-start;
  justify-content: space-between;
  width: 100%;
  @media only screen and (max-width: 950px) {
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 23px;
    color: #475467;
  }
`;

export const TitleLocation = styled.h4`
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 15px;
  display: flex;
  align-items: center;
  color: #667085;
  svg {
    color: '#36397A';
    margin-right: 12px;
  }
  @media only screen and (max-width: 950px) {
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 15px;
    color: #667085;
  }
`;

export const TitleItems = styled.h4`
  font-weight: 400;
  font-size: 16px;
  line-height: 18px;
  color: #667085;
  display: flex;
  align-items: center;
  svg {
    color: #667085;
    margin-right: 12px;
  }
  @media only screen and (max-width: 950px) {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #667085;
    flex-wrap: nowrap;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const Tag = styled.div`
  h3 {
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
    text-align: center;
    color: #667085;
  }
  @media only screen and (max-width: 950px) {
    h3 {
      font-style: normal;
      font-weight: 400;
      font-size: 18px;
      line-height: 24px;
    }
  }
`;

export const Row = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: flex-start;
`;
